import { Button } from '@timelyapp/react';
import classNames from 'classnames';
import React from 'react';
import styles from './GlobalMessages.module.scss';

interface Props {
  variant: 'warning' | 'error' | 'info' | 'cta';
  children: React.ReactNode;
  onDismiss?: () => unknown;
}

const MessageBar: React.FC<Props> = (props: Props) => {
  const { variant, children, onDismiss } = props;
  const showDismissal = !!onDismiss;
  const containerClass = classNames(styles.banner, styles[`variant-${variant}`]);

  return (
    <div className={containerClass}>
      {children}
      {showDismissal && (
        <div className={styles.close}>
          <Button size="small" priority="low" onClick={onDismiss}>
            Dismiss
          </Button>
        </div>
      )}
    </div>
  );
};

export default MessageBar;
